import { render, staticRenderFns } from "./ytCert.vue?vue&type=template&id=b730d65a&scoped=true"
import script from "./ytCert.vue?vue&type=script&lang=js"
export * from "./ytCert.vue?vue&type=script&lang=js"
import style0 from "./ytCert.vue?vue&type=style&index=0&id=b730d65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b730d65a",
  null
  
)

export default component.exports